/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const SecurityDateIcon = ({ width, height }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-secure-data"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-secure-data:not(.animated) .animable {opacity: 0;}svg#freepik_stories-secure-data.animated #freepik--background-complete--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-secure-data.animated #freepik--Table--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-secure-data.animated #freepik--Character--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-secure-data.animated #freepik--Shield--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-secure-data.animated #freepik--Device--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}            @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ',
        }}
      />
      <g
        id="freepik--background-complete--inject-2"
        style={{ transformOrigin: '241.96643829345703px 263.3150177001953px' }}
        className="animable"
      >
        <path
          d="M99.24,400.06c13.84-11.33,15.63-30.37,13.67-47.19-.33-2.81-.26-5.8-1.82-8.16s-4.86-3.79-7.32-2.39c-2,1.16-2.76,3.67-3.78,5.78A16.77,16.77,0,0,1,93.81,355c-1.74,1.08-3.94,1.83-5.82,1-2.57-1.14-3.13-4.47-3.34-7.27q-.6-7.83-1.18-15.67a26.15,26.15,0,0,0-1.54-8.25c-1.1-2.58-3.25-4.89-6-5.41s-6,1.28-6.32,4.07a25.77,25.77,0,0,0,.2,3.5,3,3,0,0,1-1.52,2.91c-1.1.42-2.3-.28-3.22-1-3.16-2.58-5.45-6.06-7.6-9.53s-4.26-7-7.17-9.9-6.79-5-10.87-4.9-8.21,2.95-8.91,7,1.95,7.85,4.75,10.83A63.17,63.17,0,0,0,49.47,333.6a5.19,5.19,0,0,1,2.39,2.16c.77,1.82-.87,3.82-2.68,4.59-2.06.87-4.38.84-6.57,1.28s-4.51,1.6-5.18,3.73c-.92,3,1.75,5.76,4.29,7.53a54.9,54.9,0,0,0,16.81,7.83c2.15.58,4.4,1.06,6.2,2.37s3,3.74,2.17,5.8-3.41,2.9-5.63,2.68-4.27-1.23-6.42-1.83c-4-1.13-9-.45-11.26,3.08a8.79,8.79,0,0,0-.31,7.92,20.51,20.51,0,0,0,4.86,6.56,54.67,54.67,0,0,0,24.62,14.24c9.3,2.35,17.75,2.5,26.48-1.48"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '71.98910140991211px 353.8734130859375px',
          }}
          id="elwb9dsjrou2j"
          className="animable"
        />
        <path
          d="M100.45,412.55a121.92,121.92,0,0,0-6.53-22.69,248,248,0,0,0-12.31-26.18L78,357c-1.18-2.2-2.35-4.38-3.63-6.44a125.32,125.32,0,0,0-8-11.41c-2.73-3.51-5.46-6.75-8-9.75s-5-5.75-7.37-8.17a101.64,101.64,0,0,0-11.91-10.56c-1.5-1.14-2.7-2-3.51-2.54l-.93-.64a3.47,3.47,0,0,0-.33-.2s.1.09.3.24l.91.67c.8.58,2,1.44,3.46,2.6a105.61,105.61,0,0,1,11.79,10.64c2.33,2.42,4.77,5.18,7.33,8.19s5.26,6.25,8,9.76a125.57,125.57,0,0,1,8,11.39c1.27,2.05,2.43,4.22,3.61,6.42l3.58,6.69A257.71,257.71,0,0,1,93.56,390a124.49,124.49,0,0,1,6.6,22.6"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '67.38499450683594px 359.9449920654297px',
          }}
          id="el1sotfzlv7t9"
          className="animable"
        />
        <path
          d="M74.29,350.51a6.17,6.17,0,0,0,.16-1.22c.08-.78.16-1.93.24-3.34.17-2.82.27-6.72.37-11s.26-8.2.49-11c.1-1.41.21-2.54.29-3.33a7.87,7.87,0,0,0,.08-1.22,6.07,6.07,0,0,0-.25,1.2c-.13.78-.28,1.92-.42,3.32-.31,2.82-.52,6.72-.62,11s-.17,8.13-.23,11c-.05,1.35-.08,2.48-.11,3.34A6.47,6.47,0,0,0,74.29,350.51Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '75.09016066789627px 334.95501708984375px',
          }}
          id="elp0g3421t0n"
          className="animable"
        />
        <path
          d="M37.26,346.79l.38,0h1.09c.94,0,2.3,0,4,.05,3.37.07,8,.33,13.15.86s9.73,1.21,13.05,1.8c1.66.29,3,.55,3.93.73l1.06.21c.25,0,.38.06.38,0a1.15,1.15,0,0,0-.36-.12l-1.05-.29c-.91-.23-2.25-.54-3.91-.86-3.31-.67-7.93-1.4-13.06-1.94s-9.8-.74-13.19-.73c-1.69,0-3,0-4,.09l-1.08.07A1.31,1.31,0,0,0,37.26,346.79Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '55.77999687194824px 348.4831142425537px',
          }}
          id="el2rnbz0qnvf8"
          className="animable"
        />
        <path
          d="M93.46,389.22a3.32,3.32,0,0,0,.2-.47c.14-.35.3-.8.51-1.35.44-1.18,1-2.91,1.74-5,1.41-4.27,3.18-10.23,5.06-16.84s3.59-12.57,4.93-16.86c.67-2.1,1.21-3.82,1.61-5.08.18-.56.32-1,.43-1.38a2.28,2.28,0,0,0,.13-.49,2,2,0,0,0-.21.46c-.13.36-.3.81-.51,1.36-.44,1.18-1,2.9-1.73,5-1.42,4.27-3.19,10.23-5.06,16.84S97,378,95.62,382.27c-.66,2.1-1.21,3.82-1.6,5.07-.18.57-.32,1-.44,1.39A2.58,2.58,0,0,0,93.46,389.22Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '100.76499557495117px 365.4850158691406px',
          }}
          id="el498qux8vfb3"
          className="animable"
        />
        <path
          d="M43.72,377.79a1.71,1.71,0,0,0,.49.15l1.45.34L51,379.5c4.5,1,10.7,2.53,17.55,4.21s13.06,3.14,17.58,4.1c2.26.48,4.09.85,5.36,1.08l1.46.26a2.89,2.89,0,0,0,.52.07,1.89,1.89,0,0,0-.5-.15l-1.45-.34-5.33-1.22c-4.5-1-10.7-2.53-17.54-4.21s-13.06-3.14-17.58-4.1c-2.26-.48-4.09-.85-5.36-1.08l-1.47-.27A3.19,3.19,0,0,0,43.72,377.79Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '68.59500122070312px 383.50502014160156px',
          }}
          id="elr8yuzd346g"
          className="animable"
        />
        <g id="elg2k3vfr6bbn">
          <rect
            x="164.05"
            y="124.09"
            width="75.5"
            height="50.89"
            style={{
              fill: 'rgb(255, 255, 255)',
              transformOrigin: '201.8px 149.535px',
              transform: 'rotate(-16.74deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M245.28,163s-.11-.31-.29-.89-.45-1.46-.8-2.58c-.69-2.26-1.71-5.57-3-9.79-2.58-8.47-6.27-20.62-10.77-35.41l.26.14L158.4,136.3h0l.18-.33,14.64,48.74-.3-.16L225,169l14.91-4.41,4-1.17,1-.3.36-.09-.32.11-1,.32-3.92,1.2-14.82,4.53L173.05,185l-.23.07-.07-.23c-4.47-14.85-9.45-31.36-14.68-48.73l-.07-.25.24-.07h0l72.31-21.7.2-.06.06.2c4.43,14.87,8.06,27.08,10.6,35.59,1.24,4.22,2.22,7.52,2.88,9.79.33,1.1.57,1.95.75,2.55S245.28,163,245.28,163Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '201.63999938964844px 149.55001068115234px',
          }}
          id="elk8vx8j3mfqs"
          className="animable"
        />
        <path
          d="M230.62,114.3a1.31,1.31,0,0,1-.1.22l-.34.62c-.33.57-.78,1.36-1.34,2.36l-5.05,8.67L206.85,154.9l-.12.19-.2-.08-2.21-.85-32.57-12.71-9.85-3.9-2.66-1.09-.69-.29a.82.82,0,0,1-.23-.12.7.7,0,0,1,.25.07l.7.24,2.71,1,9.9,3.75,32.62,12.56,2.22.86-.32.11c6.7-11.25,12.72-21.33,17.08-28.66l5.19-8.58c.6-1,1.08-1.75,1.42-2.32l.39-.59C230.56,114.36,230.61,114.29,230.62,114.3Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '194.4699935913086px 134.69452476501465px',
          }}
          id="elyz175wbv51"
          className="animable"
        />
        <path
          d="M441,309s-4.69-4.64-13.83,6.95A172.23,172.23,0,0,0,414,334.44s-2.28,2.36-3.78.22-3.05-7.66-6.39-7.38-5.26,3.72-5.71,9.21-1.86,17.5-2,18.58-1,2.49-2.29,1.2S386.05,344,381,347.38s-3.77,18.92-3.66,20.61-.35,2.33-1.19,2.57-2.69-3.66-4.68-6.71-4.82-6.26-7.56-4.05-5.65,13.08,1.27,33.05l3.81,9,9.75,1.39c21.07,1.69,30.87-3.84,32.32-7.05s-2.35-5.15-5.81-6.31-7.7-2-7.67-2.85.52-1.47,2.19-1.79,17-3,19-8.71-10.25-9.29-11.82-10.19-.41-2.13.59-2.52,12.28-4.78,17.49-6.58,8.08-4.42,7.49-7.84-6.3-3.41-8.75-4.34-.73-3.71-.73-3.71a171.54,171.54,0,0,0,14.67-17.35c8.93-11.76,3.11-15.19,3.11-15.19"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '401.79035568237305px 355.8183479309082px',
          }}
          id="eledcbv3hfd2a"
          className="animable"
        />
        <path
          d="M432.76,319.32a1.48,1.48,0,0,1-.16.25l-.51.72c-.48.64-1.15,1.55-2,2.71-1.75,2.35-4.3,5.73-7.48,9.89-6.35,8.32-15.23,19.74-25.09,32.3L372.3,397.4l-7.61,9.79-2.08,2.65-.55.68c-.13.15-.19.23-.2.22a1.48,1.48,0,0,1,.16-.25l.51-.71,2-2.72c1.74-2.35,4.3-5.73,7.47-9.89,6.35-8.32,15.24-19.74,25.11-32.3s18.74-23.94,25.21-32.21c3.19-4.11,5.79-7.44,7.61-9.78.88-1.13,1.58-2,2.07-2.66l.56-.68C432.68,319.39,432.75,319.31,432.76,319.32Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '397.3100128173828px 365.03001403808594px',
          }}
          id="el1fafvs5hsge"
          className="animable"
        />
        <path
          d="M405.69,335.09a12.25,12.25,0,0,1,.37,2.62c.15,1.62.28,3.87.37,6.36s.13,4.55.18,6.36a15.8,15.8,0,0,1,0,2.64,11.94,11.94,0,0,1-.36-2.62c-.13-1.63-.24-3.88-.33-6.36s-.15-4.55-.22-6.36A15.24,15.24,0,0,1,405.69,335.09Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '406.15143156051636px 344.0799865722656px',
          }}
          id="elq2b0t6lkajh"
          className="animable"
        />
        <path
          d="M407.45,353.42a101.64,101.64,0,0,1,10.33-1.13c5.71-.47,10.36-.74,10.37-.6a103.08,103.08,0,0,1-10.33,1.12C412.11,353.29,407.47,353.56,407.45,353.42Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '417.8000030517578px 352.55499053001404px',
          }}
          id="elmdhrtjt2d8b"
          className="animable"
        />
        <path
          d="M390.86,372.7a16.19,16.19,0,0,1,2.66.43c1.64.31,3.89.74,6.39,1.14s4.77.7,6.42.91a16.89,16.89,0,0,1,2.67.43,12.56,12.56,0,0,1-2.7-.06c-1.67-.12-4-.36-6.47-.77s-4.77-.89-6.39-1.29A12.61,12.61,0,0,1,390.86,372.7Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '399.9300079345703px 374.17796099185944px',
          }}
          id="elygozdbr6yj"
          className="animable"
        />
        <path
          d="M385.62,356.48a11.56,11.56,0,0,1,1,2.29c.53,1.45,1.24,3.45,2,5.67s1.4,4.24,1.85,5.72a13.26,13.26,0,0,1,.62,2.41,10.83,10.83,0,0,1-1-2.3c-.54-1.44-1.24-3.44-2-5.66s-1.4-4.25-1.85-5.72A11.44,11.44,0,0,1,385.62,356.48Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '388.35499572753906px 364.52500915527344px',
          }}
          id="eldz01th06n9"
          className="animable"
        />
        <path
          d="M368.81,371.64a20.84,20.84,0,0,1,1.22,2.95c.69,1.85,1.61,4.41,2.6,7.25s1.85,5.42,2.46,7.29a19,19,0,0,1,.87,3.08,19.36,19.36,0,0,1-1.22-3c-.69-1.84-1.61-4.4-2.6-7.24s-1.86-5.42-2.46-7.3A18.78,18.78,0,0,1,368.81,371.64Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '372.385009765625px 381.9250183105469px',
          }}
          id="elnml69cbduj"
          className="animable"
        />
        <path
          d="M375.93,391.67a23.75,23.75,0,0,1,3.39.44c2.08.33,5,.78,8.15,1.2s6.08.74,8.17,1a25.75,25.75,0,0,1,3.39.45,20.38,20.38,0,0,1-3.42-.08c-2.11-.14-5-.4-8.21-.83s-6.08-.93-8.15-1.34A21,21,0,0,1,375.93,391.67Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '387.4800109863281px 393.2337658405304px',
          }}
          id="el8mih2dk4n5l"
          className="animable"
        />
        <g id="el73usepf9hgr">
          <rect
            x="385.21"
            y="221.9"
            width="77.59"
            height="56.7"
            style={{
              fill: 'rgb(245, 245, 245)',
              transformOrigin: '424.005px 250.25px',
              transform: 'rotate(-88.25deg)',
            }}
            className="animable"
          />
        </g>
        <g id="ellgohazvtnki">
          <rect
            x="374.77"
            y="232.2"
            width="77.59"
            height="56.7"
            style={{
              fill: 'rgb(255, 255, 255)',
              transformOrigin: '413.565px 260.55px',
              transform: 'rotate(-88.25deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M440.72,300.19a3.64,3.64,0,0,1,0-.38c0-.26,0-.62,0-1.09,0-1,.05-2.4.1-4.24.1-3.71.24-9.1.42-15.93.39-13.65.94-33,1.59-55.91l.23.24-56.67-1.71h0l.27-.25c-.91,29-1.74,55.79-2.42,77.55l-.21-.22,41.16,1.37,11.45.4,3,.12,1.05.05h-1l-3-.07-11.4-.29L384,298.68h-.21v-.21c.65-21.77,1.45-48.59,2.32-77.56v-.26h.27l56.66,1.76h.24v.24c-.75,23-1.38,42.38-1.83,56.06-.23,6.8-.42,12.18-.54,15.87-.07,1.82-.12,3.22-.16,4.19,0,.46,0,.82-.05,1.07S440.72,300.19,440.72,300.19Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '413.5350036621094px 260.42000579833984px',
          }}
          id="elm7w5z51s74e"
          className="animable"
        />
        <path
          d="M421,238.86c0,.15-6.17.07-13.77-.16s-13.77-.54-13.77-.68,6.18-.07,13.78.16S421,238.72,421,238.86Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '407.2300109863281px 238.44221785664558px',
          }}
          id="elhq3ok0gcd2d"
          className="animable"
        />
        <path
          d="M435.64,246.06c0,.14-9.5,0-21.22-.39s-21.22-.77-21.21-.91,9.5,0,21.23.39S435.65,245.91,435.64,246.06Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '414.4250259399414px 245.40999567508698px',
          }}
          id="el4ejjopc7nh6"
          className="animable"
        />
        <path
          d="M435.43,253.09c0,.14-9.51,0-21.23-.39s-21.21-.77-21.21-.91,9.51,0,21.23.39S435.43,252.94,435.43,253.09Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '414.2099914550781px 252.43999445438385px',
          }}
          id="el0jozml1heoxp"
          className="animable"
        />
        <path
          d="M435.21,260.12c0,.14-9.5,0-21.22-.39s-21.21-.77-21.21-.91,9.51,0,21.23.39S435.22,260,435.21,260.12Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '413.99499893188477px 259.4699918627739px',
          }}
          id="el2xg446b949j"
          className="animable"
        />
        <path
          d="M435,267.15c0,.14-9.51,0-21.22-.39s-21.22-.77-21.22-.91,9.51,0,21.23.39S435,267,435,267.15Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '413.7799987792969px 266.49999064207077px',
          }}
          id="elmmgeuennehs"
          className="animable"
        />
        <path
          d="M434.79,274.18c0,.14-9.51,0-21.23-.39s-21.21-.77-21.21-.91,9.51,0,21.23.39S434.79,274,434.79,274.18Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '413.57000732421875px 273.52998942136765px',
          }}
          id="eleg3yqsh6bvn"
          className="animable"
        />
        <path
          d="M434.57,281.21c0,.14-9.51,0-21.22-.39s-21.22-.77-21.21-.91,9.5,0,21.22.39S434.58,281.06,434.57,281.21Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '413.35501861572266px 280.5599882006645px',
          }}
          id="eldwrylturab6"
          className="animable"
        />
        <path
          d="M414.73,287.64c0,.14-5.11.1-11.41-.09s-11.4-.47-11.4-.61,5.11-.1,11.41.09S414.73,287.49,414.73,287.64Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '403.32501220703125px 287.29002180695534px',
          }}
          id="ele9c9zim4nf6"
          className="animable"
        />
        <g id="elx6u226e3j4j">
          <rect
            x="267.87"
            y="153.35"
            width="47.94"
            height="59.96"
            style={{
              fill: 'rgb(255, 255, 255)',
              transformOrigin: '291.84000000000003px 183.32999999999998px',
              transform: 'rotate(-68.29deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M328.55,172.15l-.27-.1-.78-.3-3-1.2L313.07,166l-40.26-16,.12-.05-17.72,44.53h0l-.06-.14,55.7,22.2-.11,0c5.36-13.42,9.81-24.54,12.91-32.31,1.56-3.88,2.78-6.93,3.61-9l1-2.37.33-.82-.31.81c-.21.54-.52,1.33-.93,2.36-.82,2.08-2,5.13-3.56,9-3.09,7.78-7.52,18.93-12.85,32.38l0,.08-.08,0L255.08,194.6l-.1,0,0-.1h0c6.41-16.08,12.46-31.28,17.74-44.53l0-.09.08,0L313.16,166l11.37,4.56,3,1.2.77.31Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '291.78499603271484px 183.2750015258789px',
          }}
          id="eli19crsf6jz"
          className="animable"
        />
        <g id="elusefud0r73q">
          <rect
            x="270.81"
            y="155.48"
            width="41.9"
            height="55.75"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '291.76px 183.355px',
              transform: 'rotate(-68.29deg)',
            }}
            className="animable"
          />
        </g>
        <polygon
          points="258.32 192.63 286.05 175.63 291.23 195.23 302.05 190.17 310.12 213.25 258.32 192.63"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '284.2200012207031px 194.44000244140625px',
          }}
          id="ell0tyuaj8ola"
          className="animable"
        />
        <path
          d="M303.19,179a4.39,4.39,0,1,1-2.45-5.7A4.38,4.38,0,0,1,303.19,179Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '299.11209201812744px 177.3766736984253px',
          }}
          id="eleyk3v0yo8eg"
          className="animable"
        />
        <path
          d="M129.45,240.86a2.61,2.61,0,0,0,1.19.19,2.12,2.12,0,0,0,1.28-.63,12.65,12.65,0,0,0,1.05-1.73l6.49-11.32,2.16-3.74,1.15-2a6.94,6.94,0,0,0,.52-1,1.82,1.82,0,0,0,0-1.06,1.75,1.75,0,0,0-.57-.91,9.66,9.66,0,0,0-1-.62l-2.23-1.24-4.64-2.6-20.66-11.59a1.87,1.87,0,0,0-2.43.6l-1.55,2.66c-1,1.76-2,3.51-3,5.22L101.41,221c-.23.39-.46.78-.68,1.17a2,2,0,0,0-.33,1.14,1.82,1.82,0,0,0,.41,1.08,3.07,3.07,0,0,0,1,.69l4.37,2.48L114,232l11.32,6.47,3.07,1.78.79.47c.18.11.27.17.26.18l-.28-.13-.82-.43-3.11-1.7-11.41-6.32L106,227.89l-4.38-2.45a3.57,3.57,0,0,1-1.13-.79,2.3,2.3,0,0,1-.51-1.36,2.39,2.39,0,0,1,.38-1.4c.22-.39.45-.78.68-1.17l5.73-9.89,3-5.22,1.57-2.69a2.39,2.39,0,0,1,3.11-.77l20.64,11.63,4.64,2.62,2.21,1.26a9.15,9.15,0,0,1,1.1.66,2.22,2.22,0,0,1,.71,1.14,2.39,2.39,0,0,1,0,1.3,7.39,7.39,0,0,1-.57,1.09l-1.17,2-2.18,3.73c-2.79,4.72-5.05,8.55-6.63,11.24a13.31,13.31,0,0,1-1.12,1.73,2.23,2.23,0,0,1-1.38.63,2,2,0,0,1-.92-.15A1.35,1.35,0,0,1,129.45,240.86Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '121.90893173217773px 221.5259075164795px',
          }}
          id="elnqspjh2w5tr"
          className="animable"
        />
        <polygon
          points="124.17 220.36 126.69 224.83 121.49 224.93 116.29 225.02 118.97 220.45 121.65 215.88 124.17 220.36"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '121.4900016784668px 220.45000457763672px',
          }}
          id="elxiaov3e7zj"
          className="animable"
        />
      </g>
      <g
        id="freepik--Table--inject-2"
        style={{ transformOrigin: '249.68498992919922px 410.9949951171875px' }}
        className="animable"
      >
        <path
          d="M463.3,411c0,.15-95.65.27-213.6.27S36.07,411.17,36.07,411s95.63-.28,213.63-.28S463.3,410.87,463.3,411Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '249.68498992919922px 410.9949951171875px',
          }}
          id="elh4x3lq74sl7"
          className="animable"
        />
      </g>
      <g
        id="freepik--Character--inject-2"
        style={{ transformOrigin: '208.21652221679688px 286.8344497680664px' }}
        className="animable"
      >
        <path
          d="M141.81,347.49l-30.19-30.33,15.18-27.88c15.18-19.44,47.32-18.19,47.32-18.19A184.26,184.26,0,0,1,221.51,274c25.53,5,23.47,21.86,23.47,21.86l3.42,62.57,3.67,50.95-94.15,1.9-16.11-63.75"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '181.8449935913086px 340.97289276123047px',
          }}
          id="elell7wty5uz"
          className="animable"
        />
        <path
          d="M192.53,408.3l-84.33,1A27.41,27.41,0,0,1,83.09,370.2l36.06-66.87L152,325.53,129.59,372l68.26,1.22Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '139.16062927246094px 356.31593322753906px',
          }}
          id="eldesz7cihnd5"
          className="animable"
        />
        <path
          d="M242,285.66l67.67,104.48-39.48,2.58s-23.58-37.15-23.05-36.39C248.08,357.73,242,285.66,242,285.66Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '275.8349914550781px 339.19000244140625px',
          }}
          id="elc7bhubzhhjj"
          className="animable"
        />
        <path
          d="M150.3,331.54a1.81,1.81,0,0,1,.09-.54c.1-.4.21-.9.36-1.52.31-1.31.77-3.21,1.24-5.57s1-5.2,1.33-8.36a43.77,43.77,0,0,0,0-10.31,27.08,27.08,0,0,0-3.49-9.61,38.89,38.89,0,0,0-5-6.77,47.61,47.61,0,0,0-4.1-4,19.45,19.45,0,0,1-1.58-1.38,2.68,2.68,0,0,1,.46.29c.28.21.73.5,1.25.93a40.2,40.2,0,0,1,4.24,3.87,37.55,37.55,0,0,1,5.16,6.77,27,27,0,0,1,3.6,9.79,43.07,43.07,0,0,1-.08,10.43,83.71,83.71,0,0,1-1.44,8.38c-.52,2.37-1,4.26-1.41,5.56-.18.65-.34,1.15-.45,1.49A3,3,0,0,1,150.3,331.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '146.64408588409424px 307.51002502441406px',
          }}
          id="el395nkyh7ag6"
          className="animable"
        />
        <path
          d="M147.58,335.14a8.41,8.41,0,0,1-.58,1.51c-.4,1-1,2.34-1.77,4-1.53,3.39-3.7,8.05-6.2,13.15s-4.86,9.67-6.61,13c-.88,1.64-1.6,3-2.11,3.87a10.45,10.45,0,0,1-.84,1.39,10,10,0,0,1,.66-1.48c.51-1,1.17-2.34,2-3.95l6.47-13c2.45-5.07,4.68-9.65,6.34-13.08.78-1.61,1.42-2.95,1.92-4A9.45,9.45,0,0,1,147.58,335.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '138.52499389648438px 353.6000061035156px',
          }}
          id="eldcis7o8yhsf"
          className="animable"
        />
        <path
          d="M192.53,408.3s0-.06,0-.17,0-.31,0-.52c.05-.48.12-1.15.2-2,.2-1.78.48-4.31.83-7.5.74-6.47,1.8-15.57,3-26.3l.24.26-24.91,0L128.38,372l-13.2-.08-3.59-.05-.94,0-.32,0a1.34,1.34,0,0,1,.32,0l.94,0,3.59-.05,13.2-.08,43.58-.07,24.91,0h.27l0,.26c-1.32,10.72-2.43,19.82-3.23,26.28-.4,3.18-.73,5.71-1,7.49q-.16,1.26-.27,2l-.08.51C192.55,408.24,192.54,408.3,192.53,408.3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '153.73501205444336px 389.9850158691406px',
          }}
          id="elp4x6bganw79"
          className="animable"
        />
        <path
          d="M130.18,372.74a21.3,21.3,0,0,1-1.68-2.11,32.82,32.82,0,0,0-9.82-8.29,25.6,25.6,0,0,1-2.36-1.3,9.33,9.33,0,0,1,2.53,1,27.12,27.12,0,0,1,9.94,8.39A9.78,9.78,0,0,1,130.18,372.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '123.24999618530273px 366.88999938964844px',
          }}
          id="el6y28bw1d7et"
          className="animable"
        />
        <path
          d="M249.8,379.36a4.81,4.81,0,0,1-.14-.87c-.07-.61-.16-1.44-.28-2.49-.23-2.16-.54-5.29-.87-9.16-.69-7.75-1.48-18.47-2.18-30.31s-1.19-22.58-1.47-30.35c-.14-3.89-.24-7-.28-9.21,0-1.05,0-1.88-.05-2.5a8.3,8.3,0,0,1,0-.87,5,5,0,0,1,.09.87c0,.61.08,1.45.14,2.5.11,2.22.26,5.35.45,9.19.37,7.77.92,18.49,1.62,30.34s1.44,22.55,2,30.31c.3,3.83.54,7,.71,9.18.08,1,.14,1.88.19,2.49A4.87,4.87,0,0,1,249.8,379.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '247.15946650505066px 336.47999572753906px',
          }}
          id="eljrkydu5ltvb"
          className="animable"
        />
        <path
          d="M174.52,322.51a9.73,9.73,0,0,1,.11-1.37c.12-.95.27-2.22.46-3.78.44-3.3,1-7.82,1.74-13.06l.38.24-6.47,4.53-6.58,4.58-.47.33.08-.57c.8-5.19,1.48-9.67,2-13,.26-1.53.46-2.79.62-3.73a7.65,7.65,0,0,1,.28-1.33,7.64,7.64,0,0,1-.12,1.36c-.12.94-.27,2.2-.47,3.75-.45,3.28-1.08,7.77-1.8,13l-.38-.24,6.57-4.6,6.48-4.51.47-.33-.08.57c-.77,5.22-1.44,9.74-1.92,13-.25,1.55-.45,2.82-.6,3.76A8,8,0,0,1,174.52,322.51Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '170.55501556396484px 308.92999267578125px',
          }}
          id="elgezf4ww7ril"
          className="animable"
        />
        <path
          d="M212.16,326.56a7.9,7.9,0,0,1-1-.95c-.65-.7-1.53-1.63-2.61-2.77l-8.93-9.68.43-.15c-.21,2.45-.43,5.11-.66,7.87s-.47,5.5-.68,8l-.05.58-.38-.43-8.69-9.8-2.48-2.86a6.7,6.7,0,0,1-.84-1.07,8.79,8.79,0,0,1,1,1l2.58,2.76,8.82,9.67-.43.15c.21-2.49.43-5.19.67-8s.46-5.42.67-7.87l.05-.57.38.42,8.8,9.81,2.51,2.87A8.44,8.44,0,0,1,212.16,326.56Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '199.21499633789062px 320.95001220703125px',
          }}
          id="elu4tbsowtmyc"
          className="animable"
        />
        <path
          d="M231.1,325.22a6.94,6.94,0,0,1-.68,1.2l-2,3.22-7.14,11.08-.24-.38L228.8,339l7.9-1.33.57-.1L237,338l-7.3,10.86L227.5,352a8.66,8.66,0,0,1-.82,1.09,9.27,9.27,0,0,1,.68-1.18l2-3.2,7.15-11,.25.38-7.9,1.37-7.79,1.32-.57.09.32-.47,7.29-11,2.14-3.15A11.13,11.13,0,0,1,231.1,325.22Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '228.88499450683594px 339.1549987792969px',
          }}
          id="elhachuq1wdev"
          className="animable"
        />
        <path
          d="M205.91,344.6a7.15,7.15,0,0,1-.68,1.19l-2,3.23-7.13,11.07-.25-.38,7.78-1.34,7.91-1.34.57-.09-.33.47-7.3,10.87-2.15,3.12a7.2,7.2,0,0,1-.82,1.08,10.2,10.2,0,0,1,.68-1.18c.52-.8,1.2-1.87,2-3.19l7.15-11,.25.38-7.9,1.37-7.79,1.31-.57.1.32-.48,7.29-11c.88-1.3,1.6-2.36,2.15-3.15A9.14,9.14,0,0,1,205.91,344.6Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '203.72000885009766px 358.5399932861328px',
          }}
          id="elkkw1u2wdbg"
          className="animable"
        />
        <path
          d="M260.34,325a9.7,9.7,0,0,1-.68,1.19l-2,3.23-7.13,11.07-.25-.38,7.78-1.34,7.91-1.34.57-.09-.32.47-7.31,10.87c-.88,1.28-1.6,2.33-2.15,3.11a6.91,6.91,0,0,1-.82,1.09,9.63,9.63,0,0,1,.69-1.18l2-3.19,7.15-11,.25.38-7.9,1.36-7.79,1.32-.56.1.31-.48,7.29-11,2.15-3.15A6.76,6.76,0,0,1,260.34,325Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '258.1600112915039px 338.9399871826172px',
          }}
          id="elcdi80l2dmf6"
          className="animable"
        />
        <path
          d="M291.74,375.34a8.17,8.17,0,0,1-1-.9L288,371.8l-9.41-9.22.42-.17c-.08,2.46-.16,5.12-.25,7.89s-.2,5.52-.29,8l0,.58-.41-.41-9.16-9.35-2.62-2.73a8.67,8.67,0,0,1-.9-1,8.67,8.67,0,0,1,1,.9l2.72,2.63,9.3,9.22-.43.17c.08-2.5.17-5.2.26-8s.2-5.43.29-7.89l0-.57.4.4,9.27,9.36,2.65,2.74A8,8,0,0,1,291.74,375.34Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '278.55999755859375px 370.3649597167969px',
          }}
          id="el24y8cftqwrs"
          className="animable"
        />
        <path
          d="M132.89,308.94a8.88,8.88,0,0,1-.68,1.19l-2,3.23-7.13,11.08-.25-.38,7.78-1.35,7.91-1.33.57-.1-.32.48-7.31,10.86-2.14,3.12a8.16,8.16,0,0,1-.82,1.08,7.65,7.65,0,0,1,.68-1.17l2-3.2c1.81-2.77,4.29-6.57,7.15-11l.25.38-7.9,1.37-7.79,1.32-.56.09.31-.47c2.93-4.4,5.45-8.2,7.29-11l2.15-3.15A8.41,8.41,0,0,1,132.89,308.94Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '130.71001815795898px 322.87998962402344px',
          }}
          id="elnp5ng2u53qc"
          className="animable"
        />
        <path
          d="M93.35,383.72a7.34,7.34,0,0,1,.92,1l2.44,2.93L105,397.88l-.44.12c.36-2.43.74-5.07,1.15-7.82s.81-5.46,1.18-7.93l.08-.57.36.46,8.06,10.32,2.29,3a8,8,0,0,1,.78,1.11,8.85,8.85,0,0,1-.91-1l-2.4-2.92L107,382.44l.44-.11c-.36,2.47-.75,5.15-1.16,7.93s-.8,5.38-1.17,7.81l-.08.57-.36-.45-8.16-10.34-2.33-3A10.41,10.41,0,0,1,93.35,383.72Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '105.90499877929688px 390.1600036621094px',
          }}
          id="elt0w983cpb3i"
          className="animable"
        />
        <path
          d="M183.65,335.3a8.63,8.63,0,0,1-1.36.18l-3.8.33-13.14,1,.16-.42,5.76,5.4,5.83,5.5.42.4-.58,0-13.07.72-3.78.16a7.87,7.87,0,0,1-1.36,0,9.37,9.37,0,0,1,1.35-.17l3.77-.3,13.06-.9-.15.42-5.85-5.48-5.74-5.42-.42-.4.57,0,13.15-.79,3.8-.19A9.14,9.14,0,0,1,183.65,335.3Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '171.18999481201172px 341.94470405578613px',
          }}
          id="el7x0dm4mkfl5"
          className="animable"
        />
        <path
          d="M161.49,385.7a11.1,11.1,0,0,1,.94,1l2.49,2.88,8.51,10.06-.44.12c.31-2.44.65-5.08,1-7.83s.71-5.48,1-7.95l.08-.58.36.45L183.71,394l2.35,3a10,10,0,0,1,.8,1.1,8.2,8.2,0,0,1-.93-1l-2.46-2.87-8.4-10,.43-.13c-.31,2.48-.65,5.16-1,7.95s-.7,5.4-1,7.84l-.08.57-.36-.44-8.37-10.18-2.38-3A7.12,7.12,0,0,1,161.49,385.7Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '174.17501831054688px 391.9300231933594px',
          }}
          id="el267taexni9c"
          className="animable"
        />
        <path
          d="M121.88,348.74a8.13,8.13,0,0,1-1.36.18l-3.79.32-13.14,1,.15-.43,5.77,5.41,5.83,5.5.42.4-.58,0-13.07.72-3.78.16A7.87,7.87,0,0,1,97,362a7.84,7.84,0,0,1,1.35-.17l3.77-.3,13.06-.91-.15.43-5.85-5.48-5.75-5.42-.41-.4.57,0,13.15-.8,3.8-.18A8.93,8.93,0,0,1,121.88,348.74Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '109.44000244140625px 355.3778467178345px',
          }}
          id="elvj2s9ylaece"
          className="animable"
        />
        <path
          d="M155.91,384.57a8.1,8.1,0,0,1-1.36.17l-3.8.33-13.14,1,.16-.43,5.76,5.41,5.83,5.5.42.4-.57,0-13.08.71-3.78.17a7.87,7.87,0,0,1-1.36,0,7.84,7.84,0,0,1,1.35-.17l3.77-.3,13.06-.91-.15.43-5.85-5.48L137.43,386l-.42-.39.57,0,13.15-.8,3.81-.18A7.57,7.57,0,0,1,155.91,384.57Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '143.4499969482422px 391.21054887771606px',
          }}
          id="elwqxm71q1757"
          className="animable"
        />
        <path
          d="M232.72,293.41a8.63,8.63,0,0,1-1.36.18l-3.8.32-13.13,1,.15-.42,5.76,5.4,5.83,5.5.42.4-.57,0-13.08.72-3.78.16a7.87,7.87,0,0,1-1.36,0,7.84,7.84,0,0,1,1.35-.17l3.77-.3,13.07-.9-.16.42L220,300.25l-5.74-5.42-.42-.4.57,0,13.15-.8,3.81-.18A9,9,0,0,1,232.72,293.41Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '220.25999450683594px 300.05005741119385px',
          }}
          id="elgor3zaar3qe"
          className="animable"
        />
        <path
          d="M195.36,384.57s16.82-4.85,22.39-6.27c2.17-.55,11.46,4.35,17.88,8.43,0,0,8.84,5.24,8.13,6.85-.79,1.78-4,1.42-9.25-1,0,0,1.82,5.27-1.75,5.15,0,0,1.77,5.7-1.57,6.29s-4.12-6.68-7.06-7.07-9-.79-9-.79-5.07,8.4-9,9-13-.47-13-.47Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '218.46530151367188px 391.8001136779785px',
          }}
          id="eld8134kmfjz5"
          className="animable"
        />
        <path
          d="M224.07,385.73a28.61,28.61,0,0,1,4.7,2.65,27.92,27.92,0,0,1,4.42,3.1,55,55,0,0,1-9.12-5.75Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '228.62999725341797px 388.6050109863281px',
          }}
          id="elm1tbphb3njn"
          className="animable"
        />
        <path
          d="M223.08,389a35.72,35.72,0,0,1,5.58,2.29A35.85,35.85,0,0,1,234,394a35,35,0,0,1-5.58-2.28A34.26,34.26,0,0,1,223.08,389Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '228.5399932861328px 391.5px',
          }}
          id="elqqc4nun703"
          className="animable"
        />
        <path
          d="M224.88,396.81a28,28,0,0,1,7.52,1,28.18,28.18,0,0,1-7.52-1Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '228.6400146484375px 397.3099647164345px',
          }}
          id="eln2cz3t50xqm"
          className="animable"
        />
        <path
          d="M173.47,211a3.45,3.45,0,0,1-4.87,4.08c-2.28-1.15-2.57-4.3-2.12-6.81s1.3-5.2.25-7.53c-.81-1.78-2.56-2.91-3.92-4.31a11.06,11.06,0,0,1-3.07-9.36,9.29,9.29,0,0,1,6.38-7.3c3.35-.93,7.48.1,10-2.33,1.81-1.76,1.92-4.63,3.32-6.73,2.17-3.26,6.76-3.78,10.64-3.25s7.82,1.78,11.62.83c3.17-.79,5.77-3,8.75-4.36a17.13,17.13,0,0,1,22.3,23.52,11,11,0,0,1-5.31,5.25"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '197.16320419311523px 188.91858291625977px',
          }}
          id="elu7bjfmyxjzd"
          className="animable"
        />
        <path
          d="M192.77,293.61h0A19.27,19.27,0,0,0,212,274.07l-.25-18.38s15.44-1.55,16.46-16.85.29-50.61.29-50.61h0A53.32,53.32,0,0,0,174.68,192l-2.36,1.63,1.15,80.94A19.27,19.27,0,0,0,192.77,293.61Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '200.53648948669434px 238.14253997802734px',
          }}
          id="elguvv7j7c1k8"
          className="animable"
        />
        <path
          d="M224.46,216a2.29,2.29,0,0,1,0-4.55.77.77,0,0,1,.37,0,2.29,2.29,0,0,1,0,4.55A1.15,1.15,0,0,1,224.46,216Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '224.64501190185547px 213.721209526062px',
          }}
          id="el0xayuv0ys5j9"
          className="animable"
        />
        <path
          d="M227.46,211.06c-.25.26-1.69-1-3.8-1.11s-3.7.88-3.91.6.15-.59.85-1.06a5.19,5.19,0,0,1,6.16.41C227.39,210.46,227.59,211,227.46,211.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '223.5940613746643px 209.88163805007935px',
          }}
          id="elsost4hjfh8b"
          className="animable"
        />
        <path
          d="M203.07,211.58a2.23,2.23,0,1,1-3.1.56A2.23,2.23,0,0,1,203.07,211.58Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '201.80063319206238px 213.41345858573914px',
          }}
          id="ele2m4i5cbohr"
          className="animable"
        />
        <path
          d="M204.46,211.67c-.26.26-1.7-1-3.8-1.11s-3.7.88-3.92.6c-.11-.13.16-.59.85-1.06a5.19,5.19,0,0,1,6.16.41C204.38,211.07,204.58,211.56,204.46,211.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '200.60465693473816px 210.49163234233856px',
          }}
          id="eld32opn7e2h7"
          className="animable"
        />
        <path
          d="M212,229.53c0-.16,1.31-.36,3.45-.54.55,0,1-.13,1.05-.42a3.12,3.12,0,0,0-.31-1.6c-.47-1.43-.94-2.87-1.44-4.38-2-6.23-3.31-11.36-3-11.46s2.17,4.87,4.14,11.1c.46,1.52.91,3,1.34,4.4a3.54,3.54,0,0,1,.18,2.31,1.43,1.43,0,0,1-1,.83,3.27,3.27,0,0,1-.95.07C213.3,229.8,212,229.7,212,229.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '214.61485171318054px 220.4885606765747px',
          }}
          id="elty1rlscoeia"
          className="animable"
        />
        <path
          d="M205,231.49a39.5,39.5,0,0,0,10.18,3.57,5.84,5.84,0,0,1-7,1.94C203.67,235.07,205,231.49,205,231.49Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '209.9984712600708px 234.4766936302185px',
          }}
          id="elgwtkfisppd"
          className="animable"
        />
        <path
          d="M211.81,255.47a35.69,35.69,0,0,1-19.66-6.76s4.12,11.27,19.47,10.73Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '201.9800033569336px 254.0843915939331px',
          }}
          id="el7i0oir1ug3e"
          className="animable"
        />
        <path
          d="M228.63,192.1s-9.25,4.7-21.5-1.12c-8-3.82-17.37-5.59-19.39-3.94s-2.29,9.85-10.13,12.4c0,0,.85,15.66-5.41,15.22s-2.82-24.77-2.82-24.77l15.13-7.76,16.61-3.47,15.75,1.91,12.22,3.09Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '198.76345825195312px 196.66455459594727px',
          }}
          id="elbjmttzuqh1b"
          className="animable"
        />
        <path
          d="M173.34,209.63c-.25-.13-10.35-3.69-10.58,6.8s10.34,8.56,10.36,8.26S173.34,209.63,173.34,209.63Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '168.04815244674683px 216.98294353485107px',
          }}
          id="elhf7p7sm1q8r"
          className="animable"
        />
        <path
          d="M170,220.64s-.19.13-.5.26a1.82,1.82,0,0,1-1.37,0c-1.1-.43-2-2.21-2-4.1a6.22,6.22,0,0,1,.57-2.61,2.13,2.13,0,0,1,1.41-1.37,1,1,0,0,1,1.07.53c.13.29.06.5.11.52s.23-.17.16-.6a1.2,1.2,0,0,0-.4-.67,1.39,1.39,0,0,0-1-.29,2.57,2.57,0,0,0-1.95,1.58,6.35,6.35,0,0,0-.7,2.91c0,2.11,1.06,4.12,2.56,4.59a2,2,0,0,0,1.68-.24C170,220.9,170,220.66,170,220.64Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '167.70001006126404px 216.88998794555664px',
          }}
          id="elm2w8rt4twe"
          className="animable"
        />
        <path
          d="M168,176.8a5.77,5.77,0,0,1,6.48,2.42,16.26,16.26,0,0,0-3-1.8A17,17,0,0,0,168,176.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '171.23999786376953px 177.89310455322266px',
          }}
          id="el7tm4zwnfn0e"
          className="animable"
        />
        <path
          d="M174.31,170.52c.19,0-.1,2.21.26,4.83a20.71,20.71,0,0,0,1.47,4.57s-.44-.37-.88-1.15a9.82,9.82,0,0,1-1.1-3.34A10.91,10.91,0,0,1,174.31,170.52Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '174.96533608436584px 175.22000885009766px',
          }}
          id="el84qxou3d94o"
          className="animable"
        />
        <path
          d="M217.4,206c-.06-.12.39-.49,1.24-.83a9.46,9.46,0,0,1,7,.07c.84.36,1.29.73,1.23.85-.13.28-2.15-.51-4.74-.51S217.52,206.31,217.4,206Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '222.1350016593933px 205.34163576364517px',
          }}
          id="el5b5rajhkxh4"
          className="animable"
        />
        <path
          d="M194,203.82c-.06-.12.39-.48,1.24-.83a9.38,9.38,0,0,1,3.51-.63,9.14,9.14,0,0,1,3.51.7c.84.36,1.28.73,1.23.86s-2.15-.51-4.75-.52S194.14,204.1,194,203.82Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '198.7442626953125px 203.1482771039009px',
          }}
          id="els9u8w5z94gd"
          className="animable"
        />
        <path
          d="M215.59,207.68a2.87,2.87,0,0,1,0,.62c0,.44,0,1,.05,1.69s0,1.62.06,2.62a9.67,9.67,0,0,0,.5,3.4,8.86,8.86,0,0,0,6.34,5.77,8.38,8.38,0,0,0,2.56.22,8.23,8.23,0,0,0,2.61-.55,8.8,8.8,0,0,0,4.32-3.49,9,9,0,0,0,1.4-5.12c0-1.79,0-3.51,0-5.16l.24.24-13-.12-3.77-.07-1,0-.37,0a10.07,10.07,0,0,1,1.29-.06l3.71-.07,13.14-.12H234v.25c0,1.65,0,3.37,0,5.16a9.44,9.44,0,0,1-1.47,5.4,9.3,9.3,0,0,1-4.58,3.69,8.67,8.67,0,0,1-2.77.57,8.92,8.92,0,0,1-2.69-.25,9.17,9.17,0,0,1-6.58-6.12,9.93,9.93,0,0,1-.44-3.54c0-1,0-1.93.05-2.69s0-1.23.05-1.67A3.76,3.76,0,0,1,215.59,207.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '224.72987461090088px 215.02283811569214px',
          }}
          id="ela6w0103znan"
          className="animable"
        />
        <path
          d="M191.08,207.16s0,.23,0,.62l0,1.69c0,.74,0,1.62.05,2.63a10.23,10.23,0,0,0,.5,3.4,9.14,9.14,0,0,0,2.21,3.49,8.88,8.88,0,0,0,4.13,2.27,8.78,8.78,0,0,0,5.18-.33,8.8,8.8,0,0,0,4.31-3.48,9,9,0,0,0,1.41-5.12c0-1.79,0-3.52,0-5.17l.24.24-13-.12-3.76-.06-1,0-.37,0a10,10,0,0,1,1.28-.06l3.71-.06,13.14-.12h.24v.24c0,1.65,0,3.38,0,5.17a9.5,9.5,0,0,1-1.48,5.4,9.31,9.31,0,0,1-4.57,3.68,8.72,8.72,0,0,1-2.77.57,9,9,0,0,1-2.7-.25,9.26,9.26,0,0,1-4.32-2.43,9.35,9.35,0,0,1-2.26-3.69,9.93,9.93,0,0,1-.44-3.54c0-1,0-1.93.06-2.69s0-1.23,0-1.67A2,2,0,0,1,191.08,207.16Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '200.07437324523926px 214.51783895492554px',
          }}
          id="elqv6f7phvdcq"
          className="animable"
        />
        <path
          d="M215.81,208.41a23,23,0,0,1-6.9,0,22.18,22.18,0,0,1,6.9,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '212.3600082397461px 208.40514945983887px',
          }}
          id="elj6tup39m38g"
          className="animable"
        />
        <path
          d="M172,208.54a90.51,90.51,0,0,1,9.56-.29,91.42,91.42,0,0,1,9.57.23,84.33,84.33,0,0,1-9.56.29A85.55,85.55,0,0,1,172,208.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '181.56501007080078px 208.5134677886963px',
          }}
          id="el12xmd6nwdl"
          className="animable"
        />
        <path
          d="M274.87,397.25a24.6,24.6,0,0,0,23.4,12.87h0a24.6,24.6,0,0,0,22.61-20.89l5.8-66.39-23.23-5.74-9.49,52S289,390.89,274.87,397.25Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '300.7749938964844px 363.6410331726074px',
          }}
          id="elz4x0c98h3zm"
          className="animable"
        />
        <path
          d="M303.24,321.91l.77-11.65s3.29-26.14,3.29-28.7c0-2.94,1.41-3.66,2.5-3.58,1.69.11,2.89,2.2,3,4.73,0,.87-.08,14.69-.08,14.69a31.82,31.82,0,0,1,2.67-3.73c2-2.59,6.84-4.07,11.77-3.91s6.28.64,6.31,2.55a2.45,2.45,0,0,1-1,1.86,4.84,4.84,0,0,1-3.25,1.12c-7.89-.14-10,4.07-10,4.07l-.1,1.53s4.79-3.43,8.61-2a4.51,4.51,0,0,1,1.52.94,6.17,6.17,0,0,1,5.35,9.2,2.56,2.56,0,0,1-2.48,1.55,3.2,3.2,0,0,1-1.39-.85,6.16,6.16,0,0,0-.71-.52l-.88,4.23s-2.49,9.4-3.11,13.62"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '319.31763458251953px 302.51709365844727px',
          }}
          id="elspkz9n7fwu"
          className="animable"
        />
        <path
          d="M305.51,321c1.44.4,2.93-.66,3.71-1.94s1.11-2.79,1.79-4.13c2.06-4,7-5.9,8.89-10,.26-.57.4-1.35-.1-1.73s-1.12-.07-1.63.21l-13,7.2"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '312.6526174545288px 312.0545063018799px',
          }}
          id="elhwah0umfxxt"
          className="animable"
        />
        <path
          d="M305.16,310.59a6.73,6.73,0,0,1,1.33-.92c.88-.55,2.17-1.31,3.77-2.24l5.65-3.23,1.63-.92a2.92,2.92,0,0,1,2.15-.61,1.23,1.23,0,0,1,.85,1.11,2.6,2.6,0,0,1-.21,1.2,9.63,9.63,0,0,1-1.12,1.88c-1.8,2.34-4.13,3.81-5.81,5.52a11.11,11.11,0,0,0-2.06,2.65c-.49.92-.8,1.88-1.18,2.75a5.23,5.23,0,0,1-3,3.24c-1.07.32-1.67,0-1.63-.06a4,4,0,0,0,1.52-.25,5.07,5.07,0,0,0,2.58-3.16,29.34,29.34,0,0,1,1.11-2.85,11.19,11.19,0,0,1,2.13-2.87c1.72-1.8,4-3.31,5.68-5.48a8.74,8.74,0,0,0,1-1.69c.25-.57.21-1.14-.11-1.2s-.95.21-1.5.52l-1.66.9L310.55,308c-1.64.87-3,1.55-3.9,2A5.69,5.69,0,0,1,305.16,310.59Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '312.8525857925415px 311.9051790237427px',
          }}
          id="elcc0b4yn23nb"
          className="animable"
        />
        <path
          d="M318.94,301a6,6,0,0,1,.91-2.66,4.72,4.72,0,0,1,2.4-1.74A12,12,0,0,1,326,296a20.23,20.23,0,0,0,3.9-.34,6.25,6.25,0,0,0,2.9-1.45,2.45,2.45,0,0,0,.78-2,1.47,1.47,0,0,0-.26-.76c-.05,0,0,.29.05.77a2.31,2.31,0,0,1-.84,1.75,6.28,6.28,0,0,1-2.74,1.24,21.36,21.36,0,0,1-3.81.28,11.88,11.88,0,0,0-3.89.61,5,5,0,0,0-2.55,2,4.39,4.39,0,0,0-.66,2.08A1.5,1.5,0,0,0,318.94,301Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '326.2184314727783px 296.22499084472656px',
          }}
          id="elm8u3dslyhq"
          className="animable"
        />
        <path
          d="M312.73,281.73a14.87,14.87,0,0,0,0,2.75c0,1.88,0,4.13.07,6.61s0,4.73,0,6.61a15.79,15.79,0,0,0,.06,2.75,11.59,11.59,0,0,0,.33-2.74c.12-1.69.2-4,.19-6.62s-.11-4.94-.23-6.63A12.87,12.87,0,0,0,312.73,281.73Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '313.02358651161194px 291.0899963378906px',
          }}
          id="el3ojjp1um10i"
          className="animable"
        />
        <path
          d="M322.06,304.07a3.22,3.22,0,0,0,.8-.31,2.57,2.57,0,0,1,2.12-.1,1.38,1.38,0,0,1,.72,1.15,7.08,7.08,0,0,1-.13,1.78,3,3,0,0,0,.33,2.16,2.62,2.62,0,0,0,2.1,1.1,3,3,0,0,0,2.16-.94,3.62,3.62,0,0,0,1-1.92,12.11,12.11,0,0,0-.05-3.54,6.9,6.9,0,0,0-.71-2.27c-.28-.5-.54-.69-.56-.67s.16.27.37.76a8.19,8.19,0,0,1,.51,2.24,13,13,0,0,1-.05,3.39,3,3,0,0,1-2.68,2.4,2.09,2.09,0,0,1-1.67-.85,2.62,2.62,0,0,1-.27-1.8,7.2,7.2,0,0,0,.08-1.91,1.77,1.77,0,0,0-1-1.43,2.63,2.63,0,0,0-2.38.26C322.28,303.85,322,304,322.06,304.07Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '326.65908432006836px 305.17929697036743px',
          }}
          id="el9dfvq968wp6"
          className="animable"
        />
        <path
          d="M329.93,308.49a1.1,1.1,0,0,0,.08.78,2.43,2.43,0,0,0,1.6,1.42,3.19,3.19,0,0,0,3-.94,5.19,5.19,0,0,0,1.35-3.63,6.36,6.36,0,0,0-1.18-3.69,5.94,5.94,0,0,0-2.47-2,5.6,5.6,0,0,0-2.06-.49c-.5,0-.77,0-.77.08a9.35,9.35,0,0,1,2.67.76,5.93,5.93,0,0,1,2.22,1.91,6.06,6.06,0,0,1,1,3.4,4.84,4.84,0,0,1-1.16,3.28,2.81,2.81,0,0,1-2.58.91,2.25,2.25,0,0,1-1.49-1.13C330,308.77,330,308.49,329.93,308.49Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '332.72090101242065px 305.3506145477295px',
          }}
          id="elx27tajg40b"
          className="animable"
        />
        <path
          d="M320.43,317.73a2.19,2.19,0,0,0-1.32,0,5.22,5.22,0,0,0-2.88,1.74l.46.14a14.64,14.64,0,0,0-.3-1.84,11.82,11.82,0,0,0-2.85-5.77,29.93,29.93,0,0,1,2.32,5.89c.14.62.24,1.22.31,1.78l.08.62.39-.49a5.45,5.45,0,0,1,2.55-1.75C319.94,317.82,320.43,317.8,320.43,317.73Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '316.98500061035156px 316.14501953125px',
          }}
          id="ellve2doavi5"
          className="animable"
        />
        <path
          d="M320.68,294.22c-.13.06.4,1,1.62,1.57s2.3.24,2.25.1-1-.13-2-.6S320.81,294.12,320.68,294.22Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '322.60624849796295px 295.16155511140823px',
          }}
          id="el7vuvwk7ghb6"
          className="animable"
        />
        <path
          d="M299.24,329.45l29.19,2.09s-4.49,51.65-5.36,59.66-6,20.09-23.83,20.09-21.15-6.07-29.08-18.57c9.35-6.48,24.2-25.83,24.2-25.83Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '299.2950134277344px 370.37001037597656px',
          }}
          id="el92rxbq18l6s"
          className="animable"
        />
        <path
          d="M313,336.4a9.85,9.85,0,0,1-.54,1.27l-1.63,3.44L305.07,353l-.29-.35,7.57-2.25,7.69-2.26.56-.16-.27.51-6,11.65-1.77,3.35a7.86,7.86,0,0,1-.69,1.17,10.59,10.59,0,0,1,.54-1.25c.42-.86,1-2,1.64-3.41l5.81-11.73.29.35-7.68,2.28-7.58,2.22-.55.16.26-.51L310.57,341c.73-1.39,1.32-2.53,1.76-3.38A8.27,8.27,0,0,1,313,336.4Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '312.4700469970703px 350.5299987792969px',
          }}
          id="el5vdku1uyx04"
          className="animable"
        />
        <path
          d="M310.24,386.08a8.63,8.63,0,0,1-1.36.18l-3.8.33-13.14,1,.16-.43,5.76,5.4,5.83,5.5.42.4-.58,0-13.07.72-3.78.16a7.87,7.87,0,0,1-1.36,0,8.75,8.75,0,0,1,1.35-.16l3.77-.31,13.06-.9-.15.43-5.85-5.49-5.74-5.42-.42-.39.57,0,13.15-.79,3.81-.19A9,9,0,0,1,310.24,386.08Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '297.78001403808594px 392.71972370147705px',
          }}
          id="el935ql8u6akh"
          className="animable"
        />
      </g>
      <g
        id="freepik--Shield--inject-2"
        style={{ transformOrigin: '332.4827117919922px 237.39500427246094px' }}
        className="animable"
      >
        <path
          d="M362.21,201.57l-29.77-10.69L303,201.43c-3.76,1.77-7.06,2.84-7.06,6.34v17.46A66,66,0,0,0,305.61,260a60.51,60.51,0,0,0,27.12,23.95c12-3.91,21-14.35,26.55-23.27A66,66,0,0,0,369,225.91v-15.7C369,205.21,366.34,202.77,362.21,201.57Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '332.4698066711426px 237.41500854492188px',
          }}
          id="elympnhdnqnd"
          className="animable"
        />
        <g id="el0g3x268ntxb7">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '314.33447074890137px 237.4350128173828px',
            }}
            className="animable"
          >
            <path
              d="M332.73,273.79a48,48,0,0,1-21.45-19.1,52.22,52.22,0,0,1-7.69-27.49V215c0-2.78,1.68-5.38,5-6.93l23.86-8.92v-8.23L303,201.43c-3.09,1.35-7.06,2.84-7.06,6.34v17.46A66,66,0,0,0,305.61,260a60.51,60.51,0,0,0,27.12,23.95Z"
              id="elyb2ki91y4y"
              style={{
                transformOrigin: '314.33447074890137px 237.4350128173828px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="el0iq67cwk0v6k">
          <g
            style={{
              opacity: '0.4',
              transformOrigin: '350.72825813293457px 237.3800048828125px',
            }}
            className="animable"
          >
            <path
              d="M332.73,283.92a36.13,36.13,0,0,0,5.85-2.5A52.72,52.72,0,0,0,351,271.68a66.59,66.59,0,0,0,8.61-11.57A63.5,63.5,0,0,0,369,225l0-14.41c0-7.18-3.7-7.71-6.8-9.06l-29.77-10.69v8.23l24.14,9.07c3.32,1.55,5,4.15,5,6.92v12.25a52.18,52.18,0,0,1-7.69,27.48,47,47,0,0,1-21.17,19Z"
              id="elvs2msrvcu3"
              style={{
                transformOrigin: '350.72825813293457px 237.3800048828125px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="elqb0it81h9qb">
          <path
            d="M340.34,226.42l0-2.36a7.73,7.73,0,0,0-15.46,0l0,2.4a4.32,4.32,0,0,0-3.68,4.27v13.9a4.32,4.32,0,0,0,4.32,4.32H340a4.32,4.32,0,0,0,4.32-4.32v-13.9A4.32,4.32,0,0,0,340.34,226.42Zm-5.63,14.74h-3.78l.59-2.73a2.29,2.29,0,1,1,2.5,0C334.28,239.45,334.71,241.16,334.71,241.16Zm4-14.76H326.55l0-2.34a6.07,6.07,0,0,1,12.13,0Z"
            style={{
              fill: 'rgb(255, 255, 255)',
              opacity: '0.5',
              transformOrigin: '332.7600107192993px 232.6399917602539px',
            }}
            className="animable"
          />
        </g>
        <path
          d="M308.42,226.25a9,9,0,0,1-.45-2.42,41.18,41.18,0,0,1-.24-5.93c0-1.16.11-2.26.21-3.26a7,7,0,0,1,.67-2.63,2.94,2.94,0,0,1,1.3-1.31c.41-.19.66-.18.66-.15a3.33,3.33,0,0,0-1.63,1.62,7.32,7.32,0,0,0-.52,2.51c-.08,1-.14,2.09-.17,3.24-.07,2.29,0,4.37.09,5.88A15.67,15.67,0,0,1,308.42,226.25Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '309.1396954059601px 218.39162683486938px',
          }}
          id="el79soty0f76"
          className="animable"
        />
        <path
          d="M308.85,233.84c-.14,0-.27-.71-.29-1.6s.09-1.61.23-1.61.27.71.29,1.6S309,233.84,308.85,233.84Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '308.82011011242867px 232.23499298095703px',
          }}
          id="eleamznpf1lyc"
          className="animable"
        />
      </g>
      <g
        id="freepik--Device--inject-2"
        style={{ transformOrigin: '293.6499938964844px 368.125px' }}
        className="animable"
      >
        <polygon
          points="279.32 325.23 246.13 407.31 186.28 407.31 186.28 411.02 364.55 411.02 401.02 325.23 279.32 325.23"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '293.6499938964844px 368.125px',
          }}
          id="elgxzafylu269"
          className="animable"
        />
        <path
          d="M330.06,373.69c-1.2,4.13-4.7,6.74-7.82,5.84s-4.67-5-3.47-9.13,4.71-6.74,7.83-5.84S331.27,369.56,330.06,373.69Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '324.4176993370056px 372.0449929237366px',
          }}
          id="el2995ni2oto7"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SecurityDateIcon;

SecurityDateIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
